// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".brand__table .ui.table tr td:hover{cursor:default}", "",{"version":3,"sources":["webpack://./avail-web-application/src/Features/Home/Features/Brands/Brands.scss"],"names":[],"mappings":"AACI,oCACI,cAAA","sourcesContent":[".brand__table .ui.table tr td {\n    &:hover {\n        cursor: default;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
